import { CampaignWizardMode } from './../../models/enums';
import { useAppDispatch } from './../../store/hooks';
import { useState, useEffect } from 'react';
import { VersionT } from "../../models/models";
import { setIsFormDirty } from '../../store/slices/appSlice';
import { EMPTY_VERSION } from '../constants';

export const useVersions = (data: VersionT[]) => {
    const [versions, setVersions] = useState<VersionT[]>(data || []);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setVersions(data);
    }, []);

    const addEmptyVersion = () => {
        // setTimeout(() => {
        //     const versionsWithNew = versions ? [...versions, EMPTY_VERSION] : [EMPTY_VERSION];
            
        //     setVersions(versionsWithNew);
        // }, 0);
    };

    const saveVersion = (
        data: any,
        index: number,
        advId: string,
        campaignId: string,
        nextProjectNumber: number,
        mode: CampaignWizardMode,
    ) => {     
        const remaining = versions.slice();

        const formattedLength = (data.RequiredLength / 1000).toString().split('')
        formattedLength.splice(1, 1);
        const newAdId = mode === CampaignWizardMode.CREATE
            ? ''
            : `${advId}-${campaignId}-${nextProjectNumber}-${formattedLength.join('')}`;

        const updatedData = {
            ...versions[index],
            ...data,
            AdId: newAdId,
        };        

        remaining.splice(index, 1, updatedData);
        setVersions(remaining);
        dispatch(setIsFormDirty(true));
    };

    const deleteVersion = (index: number) => {
        const remaining = versions.slice();

        remaining.splice(index, 1);
        setVersions(remaining);
        dispatch(setIsFormDirty(true));
    };

    return {
        versions,
        setVersions,
        addEmptyVersion,
        saveVersion,
        deleteVersion,
    };
}